export const SET_INFRASTRUKTURSTATI = 'set_infrastrukturstati';
export const SET_INFRASTRUKTURSTATI_LOADED = 'set_infrastrukturstati_loaded';

export const SET_INFRASTRUKTURSUBSTATI = 'set_infrastruktursubstati';
export const SET_INFRASTRUKTURSUBSTATI_LOADED = 'set_infrastruktursubstati_loaded';

export const SET_INFRASTRUKTURTYPEN = 'set_infrastrukturtypen';
export const ADD_INFRASTRUKTURTYP = 'add_infrastrukturtyp';
export const SET_INFRASTRUKTURTYPEN_LOADED = 'set_infrastrukturtypen_loaded';

export const SET_INFRASTRUKTURGRUPPEN = 'set_infrastrukturgruppen';
export const SET_INFRASTRUKTURGRUPPEN_LOADED = 'set_infrastrukturruppen_loaded';

export const SET_STANDORTE = 'set_standorte';
export const SET_STANDORTE_LOADED = 'set_standorte_loaded';

export const SET_ANZAHL_INFRASTRUKTUR = 'set_anzahl_infrastruktur';

export const SET_INFRASTRUKTUR_KATEGORIEN = 'set_infrastruktur_kategorien';
export const SET_INFRASTRUKTUR_KATEGORIEN_LOADED = 'set_infrastruktur_kategorien_loaded';
